var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEckoOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1571.73,
    height: 1571.754,
    viewBox: "0 0 1571.73 1571.754",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_113078",
    "data-name": "Group 113078",
    transform: "translate(-84.466 -84.469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112606",
    "data-name": "Group 112606",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143780",
    "data-name": "Path 143780",
    d: "M-270.49,8584.133c-433.319,0-785.856-352.559-785.856-785.883s352.537-785.871,785.856-785.871S515.385,7364.93,515.385,7798.25,162.837,8584.133-270.49,8584.133Zm0-1497.434c-392.324,0-711.518,319.207-711.518,711.551s319.194,711.52,711.518,711.52c392.345,0,711.523-319.187,711.523-711.52S121.855,7086.7-270.49,7086.7Z",
    transform: "translate(1140.812 -6927.911)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_143464",
    "data-name": "Path 143464",
    d: "M-1097.845,7161.105l-44.451-44.48-98.052-98.094,98.052-98.113,44.451-44.445,44.459,44.445,98.043,98.113-98.043,98.094Zm0,137.477v293.164l-426.7-426.7,146.628-146.555ZM-1524.543,6872v293.051l146.628-146.555,280.07-280.031V6445.273Z",
    transform: "translate(2105.567 -6145.465)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEckoOutline);
export default __webpack_public_path__ + "static/media/ecko-outline.69d59e3925432429816af26989974f82.svg";
export { ForwardRef as ReactComponent };